import React, {Fragment, useEffect, useState} from "react";
import {Listbox, Transition} from "@headlessui/react"

export interface MultiSelectFormItem {
    isSelected: boolean,
    name: number | string,
    id: any
}

interface IProps {
    title?: string,
    placeholder?: string,
    data: Array<MultiSelectFormItem>,
    errMsg?: string,
    onChange?: (data: Array<MultiSelectFormItem>) => void
}

function MultiSelectForm(props: IProps) {
    const {title, data, placeholder = "", onChange} = props
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [activeData, setActiveData] = useState<Array<MultiSelectFormItem>>(data)

    useEffect(() => {
        if (!isOpen) {
            const data = activeData.filter(({isSelected}) => {
                return isSelected
            })
            onChange && onChange(data)
        }
    }, [isOpen])

    const onSelect = (id: any) => {
        const data = activeData.map((_item) => {
            let item = Object.assign({}, _item)
            if (_item.id === id) {
                item.isSelected = !_item.isSelected
            }
            return item
        })
        setActiveData(data)
    }

    const selectedList = activeData.filter((_item) => {
        return _item.isSelected
    })

    const $resultList = selectedList.map(({name}, idx) => {
        return <div key={idx} className={"my-0.5 lg:my-0"}>
            <p className={"text-xs text-white bg-theme-blue p-1 rounded-md"}>{name}</p>
        </div>
    })

    const $bg = isOpen ? (
        <div onClick={() => {
            setIsOpen(false)
        }} className={"fixed inset-0 h-full w-full z-10"} />
    ) : null

    const $placeholder = selectedList.length ? (<p className={"text-sm text-left \"text-gray-500"}>{placeholder}</p>) : null
    const $selectedContent = selectedList.length ? $resultList : $placeholder
    return (
        <div>
            {$bg}
            <p className={"relative text-gray-1 text-sm text-left mb-1"}>{title}</p>
            <div className={"relative w-full"}>
                <Listbox value={null} onChange={(id) => {
                    onSelect && onSelect(id)
                }}>
                    <div className="w-full">
                        <button type={"button"} onClick={() => {
                            setIsOpen(!isOpen)
                        }} className={`w-full py-2 px-4 flex flex-row items-center justify-between bg-gray-6 rounded-md focus:outline-none ${isOpen ? "border border-transparent focus:border-theme-blue focus:ring-4 focus:ring-color-theme" : ""}`}>
                            <div className={"w-full flex-wrap flex flex-row space-x-1"}>
                                {$selectedContent}
                            </div>
                            <div className={"h-6 flex items-center justify-center"}>
                                <svg width="13" height="6" viewBox="0 0 13 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 2.25L6.51841 3.99079L3.03683 2.25" stroke="#BDBDBD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                        </button>
                        {activeData.length ? (
                            <Transition
                                show={isOpen}
                                as={Fragment}
                                enter="transition duration-100 ease-out"
                                enterFrom="transform scale-95 opacity-0"
                                enterTo="transform scale-100 opacity-100"
                                leave="transition duration-75 ease-out"
                                leaveFrom="transform scale-100 opacity-100"
                                leaveTo="transform scale-95 opacity-0"
                            >
                                <Listbox.Options static className="z-30 bg-white absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-lg shadow-2xl border max-h-60 focus:outline-none">
                                    {activeData.map((item, idx) => {
                                        const title = item.name
                                        return (
                                            <Listbox.Option
                                                key={idx}
                                                value={item.id}
                                                className={"px-1"}
                                            >
                                                {() => {
                                                    return (
                                                        <div
                                                            className={"rounded bg-white flex flex-row items-center text-gray-1 hover:text-theme-blue font-normal w-full py-2 px-4 text-sm hover:font-semibold hover:bg-theme-blue-10"}
                                                        >
                                                            <span>
                                                                <input readOnly={true} checked={item.isSelected} type={"checkbox"} className={"form-checkbox w-5 h-5 mr-2.5 border-2 rounded-md "} />
                                                            </span>
                                                            {title}
                                                        </div>
                                                    )
                                                }}
                                            </Listbox.Option>
                                        )
                                    })}
                                </Listbox.Options>
                            </Transition>
                        ) : null}
                    </div>
                </Listbox>
            </div>
        </div>
    )
}

export default MultiSelectForm
